<template>
<div class="chapter">
<div class="inner_page">
<h1 class="section"><strong class="bold">BREASTS AND EGGS</strong> </h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// breastsandeggs_00000.vue?39f3051c